import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getCentralizedTravellersInfoDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  centralizedSingleCabinLuggagePolicyPageContent: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Tab Name (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Tab Name (EN)",
      placeholder: "Enter Tab Name (EN)",
      validation: { required: "Tab Name (EN) is required" },
    },
    {
      fieldName: "Tab Name (MS)",
      fieldValue: "title_malay",
      className: "col-span-6",
      type: "text",
      name: "title_malay",
      formType: "input",
      label: "Tab Name (MS)",
      placeholder: "Enter Tab Name (MS)",
      // validation: { required: "Tab Name (MS) is required" },
    },
    {
      fieldName: "Tab Name (ZH)",
      fieldValue: "title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "title_mandarin",
      formType: "input",
      label: "Tab Name (ZH)",
      placeholder: "Enter Tab Name (ZH)",
      // validation: { required: "Tab Name (ZH) is required" },
    },
    {
      fieldName: "Content 1 (EN)",
      fieldValue: "description_english_1",
      className: "col-span-6",
      type: "text",
      name: "description_english_1",
      formType: "richText",
      label: "Content 1 (EN)",
      placeholder: "Enter Content (EN)",
      validation: { required: "Content (EN) is required" },
    },
    {
      fieldName: "Content 1 (MS)",
      fieldValue: "description_malay_1",
      className: "col-span-6",
      type: "text",
      name: "description_malay_1",
      formType: "richText",
      label: "Content 1 (MS)",
      placeholder: "Enter Content (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Content 1 (ZH)",
      fieldValue: "description_mandarin_1",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin_1",
      formType: "richText",
      label: "Content 1 (ZH)",
      placeholder: "Enter Content (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
    {
      fieldName: "Content 2 (EN)",
      fieldValue: "description_english_2",
      className: "col-span-6",
      type: "text",
      name: "description_english_2",
      formType: "richText",
      label: "Content 2 (EN)",
      placeholder: "Enter Content (EN)",
      validation: { required: "Content (EN) is required" },
    },
    {
      fieldName: "Content 2 (MS)",
      fieldValue: "description_malay_2",
      className: "col-span-6",
      type: "text",
      name: "description_malay_2",
      formType: "richText",
      label: "Content 2 (MS)",
      placeholder: "Enter Content (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Content 2 (ZH)",
      fieldValue: "description_mandarin_2",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin_2",
      formType: "richText",
      label: "Content 2 (ZH)",
      placeholder: "Enter Content (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
    {
      fieldName: "Content 3 (EN)",
      fieldValue: "description_english_3",
      className: "col-span-6",
      type: "text",
      name: "description_english_3",
      formType: "richText",
      label: "Content 3 (EN)",
      placeholder: "Enter Content (EN)",
      validation: { required: "Content (EN) is required" },
    },
    {
      fieldName: "Content 3 (MS)",
      fieldValue: "description_malay_3",
      className: "col-span-6",
      type: "text",
      name: "description_malay_3",
      formType: "richText",
      label: "Content 3 (MS)",
      placeholder: "Enter Content (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Content 3 (ZH)",
      fieldValue: "description_mandarin_3",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin_3",
      formType: "richText",
      label: "Content 3 (ZH)",
      placeholder: "Enter Content (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
  ],
  centralizedSingleCabinLuggagePolicyPageImage: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required", min: 400, max: 400 },
      imageDimension: {
        width: 400,
        height: 260,
      },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "title_malay",
      className: "col-span-6",
      type: "text",
      name: "title_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "title_mandarin",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedGuidelinesForCheckedinLuggagePageContent: [
    {
      fieldName: "Tab Name (EN)",
      fieldValue: "tab_title_english",
      className: "col-span-6",
      type: "text",
      name: "tab_title_english",
      formType: "input",
      label: "Tab Name (EN)",
      placeholder: "Enter Tab Name (EN)",
      validation: { required: "Tab Name (EN) is required" },
    },
    {
      fieldName: "Tab Name (MS)",
      fieldValue: "tab_title_malay",
      className: "col-span-6",
      type: "text",
      name: "tab_title_malay",
      formType: "input",
      label: "Tab Name (MS)",
      placeholder: "Enter Tab Name (MS)",
      // validation: { required: "Tab Name (MS) is required" },
    },

    {
      fieldName: "Tab Name (ZH)",
      fieldValue: "tab_title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "tab_title_mandarin",
      formType: "input",
      label: "Tab Name (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "title_malay",
      className: "col-span-6",
      type: "text",
      name: "title_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "title_mandarin",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
  ],
  centralizedGuidelinesForCheckedinLuggagePageImage: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "title_malay",
      className: "col-span-6",
      type: "text",
      name: "title_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "title_mandarin",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedLagsPageContent: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Tab Name (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Tab Name (EN)",
      placeholder: "Enter Tab Name (EN)",
      validation: { required: "Tab Name (EN) is required" },
    },
    {
      fieldName: "Tab Name (MS)",
      fieldValue: "title_malay",
      className: "col-span-6",
      type: "text",
      name: "title_malay",
      formType: "input",
      label: "Tab Name (MS)",
      placeholder: "Enter Tab Name (MS)",
      // validation: { required: "Tab Name (MS) is required" },
    },
    {
      fieldName: "Tab Name (ZH)",
      fieldValue: "title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "title_mandarin",
      formType: "input",
      label: "Tab Name (ZH)",
      placeholder: "Enter Tab Name (ZH)",
      // validation: { required: "Tab Name (ZH) is required" },
    },
    {
      fieldName: "Section 1 Content (EN)",
      fieldValue: "body",
      className: "col-span-6",
      type: "text",
      name: "body",
      formType: "richText",
      label: "Section 1 Content (EN)",
      placeholder: "Enter Section 1 Content (EN)",
      validation: { required: "Section 1 Content (EN) is required" },
    },
    {
      fieldName: "Section 1 Content (MS)",
      fieldValue: "description_malay_1",
      className: "col-span-6",
      type: "text",
      name: "description_malay_1",
      formType: "richText",
      label: "Section 1 Content (MS)",
      placeholder: "Enter Section 1 Content (MS)",
      // validation: { required: "Section 1 Content (MS) is required" },
    },
    {
      fieldName: "Section 1 Content (ZH)",
      fieldValue: "description_mandarin_1",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin_1",
      formType: "richText",
      label: "Section 1 Content (ZH)",
      placeholder: "Enter Section 1 Content (ZH)",
      // validation: { required: "Section 1 Content (ZH) is required" },
    },
    {
      fieldName: "Section 2 Content (EN)",
      fieldValue: "description_english_2",
      className: "col-span-6",
      type: "text",
      name: "description_english_2",
      formType: "input",
      label: "Section 2 Content (EN)",
      placeholder: "Enter Section 2 Content (EN)",
      validation: { required: "Section 2 Content (EN) is required" },
    },
    {
      fieldName: "Section 2 Content (MS)",
      fieldValue: "description_malay_2",
      className: "col-span-6",
      type: "text",
      name: "description_malay_2",
      formType: "input",
      label: "Section 2 Content (MS)",
      placeholder: "Enter Section 2 Content (MS)",
      // validation: { required: "Section 2 Content (MS) is required" },
    },
    {
      fieldName: "Section 2 Content (ZH)",
      fieldValue: "description_mandarin_2",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin_2",
      formType: "input",
      label: "Section 2 Content (ZH)",
      placeholder: "Enter Section 2 Content (ZH)",
      // validation: { required: "Section 2 Content (ZH) is required" },
    },
    // {
    //   fieldName: "Step 1 Content (EN)",
    //   fieldValue: "description_english_3",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "description_english_3",
    //   formType: "richText",
    //   label: "Step 1 Content (EN)",
    //   placeholder: "Enter Step 1 Content (EN)",
    //   validation: { required: "Step 1 Content (EN) is required" },
    // },
    // {
    //   fieldName: "Step 1 Content (MS)",
    //   fieldValue: "description_malay_3",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "description_malay_3",
    //   formType: "richText",
    //   label: "Step 1 Content (MS)",
    //   placeholder: "Enter Step 1 Content (MS)",
    //   // validation: { required: "Step 1 Content (MS) is required" },
    // },
    // {
    //   fieldName: "Step 1 Content (ZH)",
    //   fieldValue: "description_mandarin_3",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "description_mandarin_3",
    //   formType: "richText",
    //   label: "Step 1 Content (ZH)",
    //   placeholder: "Enter Step 1 Content (ZH)",
    //   // validation: { required: "Step 1 Content (ZH) is required" },
    // },
    // {
    //   fieldName: "Step 2 Content (EN)",
    //   fieldValue: "description_english_4",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "description_english_4",
    //   formType: "richText",
    //   label: "Step 2 Content (EN)",
    //   placeholder: "Enter Step 2 Content (EN)",
    //   validation: { required: "Step 2 Content (EN) is required" },
    // },
    // {
    //   fieldName: "Step 2 Content (MS)",
    //   fieldValue: "description_malay_4",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "description_malay_4",
    //   formType: "richText",
    //   label: "Step 2 Content (MS)",
    //   placeholder: "Enter Step 2 Content (MS)",
    //   // validation: { required: "Step 2 Content (MS) is required" },
    // },
    // {
    //   fieldName: "Step 2 Content (ZH)",
    //   fieldValue: "description_mandarin_4",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "description_mandarin_4",
    //   formType: "richText",
    //   label: "Step 2 Content (ZH)",
    //   placeholder: "Enter Step 2 Content (ZH)",
    //   // validation: { required: "Step 2 Content (ZH) is required" },
    // },
    {
      fieldName: "Section 3 Content (EN)",
      fieldValue: "description_english_5",
      className: "col-span-6",
      type: "text",
      name: "description_english_5",
      formType: "input",
      label: "Section 3 Content (EN)",
      placeholder: "Enter Section 3 Content (EN)",
      validation: { required: "Section 3 Content (EN) is required" },
    },
    {
      fieldName: "Section 3 Content (MS)",
      fieldValue: "description_malay_5",
      className: "col-span-6",
      type: "text",
      name: "description_malay_5",
      formType: "input",
      label: "Section 3 Content (MS)",
      placeholder: "Enter Section 3 Content (MS)",
      // validation: { required: "Section 3 Content (MS) is required" },
    },
    {
      fieldName: "Section 3 Content (ZH)",
      fieldValue: "description_mandarin_5",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin_5",
      formType: "input",
      label: "Section 3 Content (ZH)",
      placeholder: "Enter Section 3 Content (ZH)",
      // validation: { required: "Section 3 Content (ZH) is required" },
    },
  ],
  centralizedLagsLiquidItemImage: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "title_malay",
      className: "col-span-6",
      type: "text",
      name: "title_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "title_mandarin",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedLagsDisclaimerContent: [
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "title_malay",
      className: "col-span-6",
      type: "text",
      name: "title_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "title_mandarin",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Content (EN)",
      fieldValue: "body",
      className: "col-span-6",
      type: "text",
      name: "body",
      formType: "richText",
      label: "Content (EN)",
      placeholder: "Enter Content (EN)",
      validation: { required: "Content (EN) is required" },
    },
    {
      fieldName: "Content (MS)",
      fieldValue: "description_malay_1",
      className: "col-span-6",
      type: "text",
      name: "description_malay_1",
      formType: "richText",
      label: "Content (MS)",
      placeholder: "Enter Content (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Content (ZH)",
      fieldValue: "description_mandarin_1",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin_1",
      formType: "richText",
      label: "Content (ZH)",
      placeholder: "Enter Content (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
    {
      fieldName: "Button Text (EN)",
      fieldValue: "button_text_english",
      className: "col-span-6",
      type: "text",
      name: "button_text_english",
      formType: "input",
      label: "Button Text (EN)",
      placeholder: "Enter Button Text (EN)",
      validation: { required: "Button Text (EN) is required" },
    },
    {
      fieldName: "Button Text (MS)",
      fieldValue: "button_text_malay",
      className: "col-span-6",
      type: "text",
      name: "button_text_malay",
      formType: "input",
      label: "Button Text (MS)",
      placeholder: "Enter Button Text (MS)",
      // validation: { required: "Button Text (MS) is required" },
    },
    {
      fieldName: "Button Text (ZH)",
      fieldValue: "button_text_mandarin",
      className: "col-span-6",
      type: "text",
      name: "button_text_mandarin",
      formType: "input",
      label: "Button Text (ZH)",
      placeholder: "Enter Button Text (ZH)",
      // validation: { required: "Button Text (ZH) is required" },
    },
    {
      fieldName: "PDF",
      fieldValue: "pdf_url",
      className: "col-span-6",
      usedFileType: ".pdf",
      type: "pdf",
      name: "pdf_url",
      formType: "file",
      label: "PDF",
      placeholder: "Enter PDF",
      validation: { required: "PDF is Required" },
    },
  ],
  centralizedLagsGuidelinesContent: [
    {
      fieldName: "Description (EN)",
      fieldValue: "description_en",
      className: "col-span-6",
      type: "text",
      name: "description_en",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "description_malay",
      className: "col-span-6",
      type: "text",
      name: "description_malay",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "description_mandarin",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedRestrictedItemsCheckedInCabinRestrictionsContent: [
    {
      fieldName: "Tab Name (EN)",
      fieldValue: "tab_title_english",
      className: "col-span-6",
      type: "text",
      name: "tab_title_english",
      formType: "input",
      label: "Tab Name (EN)",
      placeholder: "Enter Tab Name (EN)",
      validation: { required: "Tab Name (EN) is required" },
    },
    {
      fieldName: "Tab Name (MS)",
      fieldValue: "tab_title_malay",
      className: "col-span-6",
      type: "text",
      name: "tab_title_malay",
      formType: "input",
      label: "Tab Name (MS)",
      placeholder: "Enter Tab Name (MS)",
      // validation: { required: "Tab Name (MS) is required" },
    },

    {
      fieldName: "Tab Name (ZH)",
      fieldValue: "tab_title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "tab_title_mandarin",
      formType: "input",
      label: "Tab Name (ZH)",
      placeholder: "Enter Tab Name (ZH)",
      // validation: { required: "Tab Name (ZH) is required" },
    },
    {
      fieldName: "Title 1 (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title 1 (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title 1 (MS)",
      fieldValue: "title_malay",
      className: "col-span-6",
      type: "text",
      name: "title_malay",
      formType: "input",
      label: "Title 1 (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title 1 (ZH)",
      fieldValue: "title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "title_mandarin",
      formType: "input",
      label: "Title 1 (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Title 2 (EN)",
      fieldValue: "body",
      className: "col-span-6",
      type: "text",
      name: "body",
      formType: "input",
      label: "Title 2 (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title 2 (MS)",
      fieldValue: "description_malay_1",
      className: "col-span-6",
      type: "text",
      name: "description_malay_1",
      formType: "input",
      label: "Title 2 (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title 2 (ZH)",
      fieldValue: "description_mandarin_1",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin_1",
      formType: "input",
      label: "Title 2 (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
  ],
  centralizedRestrictedItemsCheckedInCabinRestrictionsImage: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "title_malay",
      className: "col-span-6",
      type: "text",
      name: "title_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "title_mandarin",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  centralizedRestrictedItemsCabinOnlyRestrictionsContent: [
    {
      fieldName: "Title (EN)",
      fieldValue: "description_english_2",
      className: "col-span-6",
      type: "text",
      name: "description_english_2",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "description_malay_2",
      className: "col-span-6",
      type: "text",
      name: "description_malay_2",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "description_mandarin_2",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin_2",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
  ],
  centralizedRestrictedItemsCabinOnlyRestrictionsImage: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "title_malay",
      className: "col-span-6",
      type: "text",
      name: "title_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "title_mandarin",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],

  centralizedLagsSteps: [
    {
      fieldName: "Description (EN)",
      fieldValue: "description_en",
      className: "col-span-6",
      type: "text",
      name: "description_en",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "description_malay",
      className: "col-span-6",
      type: "text",
      name: "description_malay",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "description_mandarin",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
};
